(() => {
  'use strict';

  const STATE_VERSION = 6;

  const PROFILE_LABELS = {
    day: 'Vooral overdag',
    balanced: 'Vrij gelijkmatig',
    evening: 'Ochtend en avond',
    night: 'Avond en nacht'
  };

  const PROFILE_FACTORS = {
    day: 0.45,
    balanced: 0.62,
    evening: 0.78,
    night: 0.88
  };

  const CONTRACT_LABELS = {
    fixed: 'Vast contract',
    variable: 'Variabel contract',
    dynamic: 'Dynamisch contract',
    unknown: 'Onbekend contract'
  };

  const ANNUAL_CARD_COPY = {
    fixed: window.ZinVoltI18n.t("fixed_tariff_calculation_assumptions_used_e8b7ae"),
    variable: window.ZinVoltI18n.t("variable_tariff_calculation_assumptions_used_f76120"),
    dynamic: window.ZinVoltI18n.t("average_rates_calculation_assumptions_used_907984"),
    unknown: window.ZinVoltI18n.t("default_assumptions_used_2c68a3")
  };

  const PLAN_LABELS = {
    ev: 'Elektrische auto',
    heatpump: 'Warmtepomp',
    solar: 'Meer zonnepanelen',
    electric: 'Elektrisch verwarmen'
  };

  const STEP_TITLES = [window.ZinVoltI18n.t("annual_figures_085512"), window.ZinVoltI18n.t("energy_contract_7c0c11"), window.ZinVoltI18n.t("consumption_62677c"), window.ZinVoltI18n.t("your_results_9e9953")];
  const STEP_SLUGS = ['jaargegevens', 'energiecontract', 'verbruik', 'uitkomst'];
  const STEP_DESCRIPTIONS = [
    window.ZinVoltI18n.t("have_your_annual_energy_statement_and_solar_ed562d"),
    window.ZinVoltI18n.t("select_your_contract_and_the_rates_to_308f74"),
    window.ZinVoltI18n.t("select_when_you_usually_use_electricity_at_bfc38e"),
    window.ZinVoltI18n.t("view_your_initial_estimate_and_see_how_055f6a")
  ];

  const numberFormatter = new Intl.NumberFormat(window.ZinVoltI18n.locale, { maximumFractionDigits: 0 });
  const moneyFormatter = new Intl.NumberFormat(window.ZinVoltI18n.locale, {
    style: 'currency',
    currency: 'EUR',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  });
  const moneyPreciseFormatter = new Intl.NumberFormat(window.ZinVoltI18n.locale, {
    style: 'currency',
    currency: 'EUR',
    minimumFractionDigits: 2,
    maximumFractionDigits: 3
  });
  const percentageFormatter = new Intl.NumberFormat(window.ZinVoltI18n.locale, {
    minimumFractionDigits: 0,
    maximumFractionDigits: 1
  });

  // Operational field values retain their existing NL representation.
  const numberFormatterBackend = new Intl.NumberFormat('nl-NL', { maximumFractionDigits: 0 });
  const moneyFormatterBackend = new Intl.NumberFormat('nl-NL', {
    style: 'currency',
    currency: 'EUR',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  });
  const moneyPreciseFormatterBackend = new Intl.NumberFormat('nl-NL', {
    style: 'currency',
    currency: 'EUR',
    minimumFractionDigits: 2,
    maximumFractionDigits: 3
  });
  const percentageFormatterBackend = new Intl.NumberFormat('nl-NL', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 1
  });
  function formatKwhBackend(value) {
    return numberFormatterBackend.format(Math.round(Number.isFinite(value) ? value : 0)) + ' kWh';
  }
  function formatMoneyBackend(value) {
    return moneyFormatterBackend.format(Number.isFinite(value) ? value : 0);
  }
  function formatMoneyPreciseBackend(value) {
    return moneyPreciseFormatterBackend.format(Number.isFinite(value) ? value : 0);
  }
  function formatPercentageBackend(value) {
    return percentageFormatterBackend.format((Number.isFinite(value) ? value : 0) * 100) + '%';
  }
  function describeChangeBackend(value) {
    if (value > 0.5) return formatMoneyBackend(Math.abs(value)) + ' meer per jaar';
    if (value < -0.5) return formatMoneyBackend(Math.abs(value)) + ' minder per jaar';
    return 'Vrijwel gelijk per jaar';
  }

  function parseLocaleNumber(value) {
    const normalized = String(value == null ? '' : value).trim().replace(/\s/g, '').replace(',', '.');
    if (!normalized || !/^-?(?:\d+\.?\d*|\.\d+)$/.test(normalized)) return Number.NaN;
    const parsed = Number(normalized);
    return Number.isFinite(parsed) ? parsed : Number.NaN;
  }

  function finiteOr(value, fallback) {
    const parsed = parseLocaleNumber(value);
    return Number.isFinite(parsed) ? parsed : fallback;
  }

  function clamp(value, min, max) {
    return Math.min(Math.max(value, min), max);
  }

  function formatKwh(value) {
    return numberFormatter.format(Math.round(Number.isFinite(value) ? value : 0)) + ' kWh';
  }

  function formatMoney(value) {
    return moneyFormatter.format(Number.isFinite(value) ? value : 0);
  }

  function formatMoneyPrecise(value) {
    return moneyPreciseFormatter.format(Number.isFinite(value) ? value : 0);
  }

  function formatPercentage(value) {
    return percentageFormatter.format((Number.isFinite(value) ? value : 0) * 100) + '%';
  }

  function formatChange(value) {
    const absolute = formatMoney(Math.abs(value));
    if (value > 0.5) return window.ZinVoltI18n.t("amount_more_19258d", {amount:absolute});
    if (value < -0.5) return window.ZinVoltI18n.t("amount_less_a4fa51", {amount:absolute});
    return window.ZinVoltI18n.t("almost_unchanged_b9fecf");
  }

  function formatEffect(value) {
    const absolute = formatMoney(Math.abs(value));
    if (value > 0.5) return window.ZinVoltI18n.t("amount_annual_benefit_6a5c88", {amount:absolute});
    if (value < -0.5) return window.ZinVoltI18n.t("amount_annual_disadvantage_7702ca", {amount:absolute});
    return window.ZinVoltI18n.t("no_positive_financial_effect_calculated_12d311");
  }

  function getCheckedValue(form, name, fallback) {
    const field = form.querySelector('input[name="' + name + '"]:checked');
    return field ? field.value : fallback;
  }

  function getInputValue(form, name) {
    const field = form.elements.namedItem(name);
    return field && typeof field.value !== 'undefined' ? field.value : '';
  }

  function collectInput(form, defaults) {
    const rateMode = getCheckedValue(form, 'rateMode', 'average');
    const useDefaults = rateMode !== 'custom';
    return {
      annualImport: parseLocaleNumber(getInputValue(form, 'annualImport')),
      annualExport: parseLocaleNumber(getInputValue(form, 'annualExport')),
      annualGeneration: parseLocaleNumber(getInputValue(form, 'annualGeneration')),
      contractType: getCheckedValue(form, 'contractType', 'fixed'),
      rateMode: rateMode,
      currentTariff: useDefaults ? defaults.currentTariff : parseLocaleNumber(getInputValue(form, 'currentTariff')),
      currentExcessCompensation: useDefaults ? defaults.currentExcessCompensation : parseLocaleNumber(getInputValue(form, 'currentExcessCompensation')),
      currentReturnCosts: useDefaults ? defaults.currentReturnCosts : parseLocaleNumber(getInputValue(form, 'currentReturnCosts')),
      futureTariff: useDefaults ? defaults.futureTariff : parseLocaleNumber(getInputValue(form, 'futureTariff')),
      futureCompensation: useDefaults ? defaults.futureCompensation : parseLocaleNumber(getInputValue(form, 'futureCompensation')),
      futureReturnCosts: useDefaults ? defaults.futureReturnCosts : parseLocaleNumber(getInputValue(form, 'futureReturnCosts')),
      profile: getCheckedValue(form, 'usageProfile', 'evening'),
      plans: Array.from(form.querySelectorAll('input[name="futurePlans"]:checked')).map((field) => field.value)
    };
  }

  function validateInput(input, throughStep) {
    const errors = [];
    const warnings = [];
    const step = throughStep || 3;

    if (step >= 1) {
      [
        ['annualImport', window.ZinVoltI18n.t("enter_your_grid_import_60ae33")],
        ['annualExport', window.ZinVoltI18n.t("enter_your_grid_export_903bee")],
        ['annualGeneration', window.ZinVoltI18n.t("enter_your_solar_generation_95651f")]
      ].forEach((entry) => {
        const value = input[entry[0]];
        if (!Number.isFinite(value)) errors.push(entry[1]);
        else if (value < 0 || value > 50000) errors.push(window.ZinVoltI18n.t("use_a_value_between_0_and_50_1dd36a"));
      });

      if (Number.isFinite(input.annualExport) && Number.isFinite(input.annualGeneration) && input.annualExport > input.annualGeneration) {
        warnings.push(window.ZinVoltI18n.t("your_grid_export_is_higher_than_the_bea245"));
      }
      if (input.annualImport === 0 && input.annualExport === 0 && input.annualGeneration === 0) {
        warnings.push(window.ZinVoltI18n.t("with_all_three_values_at_zero_the_c944ba"));
      }
      if ([input.annualImport, input.annualExport, input.annualGeneration].some((value) => Number.isFinite(value) && value > 25000)) {
        warnings.push(window.ZinVoltI18n.t("one_of_your_annual_figures_exceeds_25_cf08ed"));
      }
    }

    if (step >= 2) {
      if (!Object.prototype.hasOwnProperty.call(CONTRACT_LABELS, input.contractType)) {
        errors.push(window.ZinVoltI18n.t("select_your_energy_contract_05ec15"));
      }
      if (input.rateMode === 'custom') {
        [
          ['currentTariff', 0, 2, window.ZinVoltI18n.t("enter_a_valid_current_electricity_rate_285cc3")],
          ['currentExcessCompensation', 0, 2, window.ZinVoltI18n.t("enter_valid_current_feed_in_compensation_e35a06")],
          ['currentReturnCosts', 0, 2, window.ZinVoltI18n.t("enter_valid_current_grid_export_charges_per_d53dfc")],
          ['futureTariff', 0, 2, window.ZinVoltI18n.t("enter_a_valid_electricity_rate_for_2027_3fd55c")],
          ['futureCompensation', 0, 2, window.ZinVoltI18n.t("enter_valid_feed_in_compensation_for_2027_9117c8")],
          ['futureReturnCosts', 0, 2, window.ZinVoltI18n.t("enter_valid_grid_export_charges_for_2027_056d47")]
        ].forEach((entry) => {
          const value = input[entry[0]];
          if (!Number.isFinite(value) || value < entry[1] || value > entry[2]) errors.push(entry[3]);
        });
      }
    }

    if (step >= 3 && !Object.prototype.hasOwnProperty.call(PROFILE_LABELS, input.profile)) {
      errors.push(window.ZinVoltI18n.t("select_when_you_usually_use_electricity_43d48b"));
    }

    return { valid: errors.length === 0, errors: Array.from(new Set(errors)), warnings: warnings };
  }

  function calculateCurrentScenario(input) {
    const directUse = Math.max(0, input.annualGeneration - input.annualExport);
    const totalConsumption = input.annualImport + directUse;
    const saldered = Math.min(input.annualImport, input.annualExport);
    const remainingImport = Math.max(0, input.annualImport - input.annualExport);
    const exportSurplus = Math.max(0, input.annualExport - input.annualImport);
    const energyCharge = remainingImport * input.currentTariff;
    const exportCredit = exportSurplus * input.currentExcessCompensation;
    const returnCharge = input.annualExport * input.currentReturnCosts;
    const cost = energyCharge - exportCredit + returnCharge;

    return {
      directUse: directUse,
      totalConsumption: totalConsumption,
      saldered: saldered,
      remainingImport: remainingImport,
      exportSurplus: exportSurplus,
      energyCharge: energyCharge,
      exportCredit: exportCredit,
      returnCharge: returnCharge,
      cost: cost
    };
  }

  function calculateFutureScenario(input) {
    const energyCharge = input.annualImport * input.futureTariff;
    const exportCredit = input.annualExport * input.futureCompensation;
    const returnCharge = input.annualExport * input.futureReturnCosts;
    const cost = energyCharge - exportCredit + returnCharge;
    return {
      energyCharge: energyCharge,
      exportCredit: exportCredit,
      returnCharge: returnCharge,
      cost: cost
    };
  }

  function simulateBattery(input, assumptions, futureScenario, product) {
    const capacity = finiteOr(product.capacity, 4);
    const efficiency = clamp(finiteOr(assumptions.efficiency, 0.9), 0.01, 1);
    const cycles = Math.max(0, finiteOr(assumptions.cycles, 220));
    const defaultProfileFactor = PROFILE_FACTORS[input.profile] || PROFILE_FACTORS.evening;
    const profileFactor = clamp(finiteOr(assumptions.profileFactor, defaultProfileFactor), 0, 1);
    const maximumAnnualCharge = capacity * cycles;
    const profileLimitedCharge = input.annualExport * profileFactor;
    const importLimitedCharge = input.annualImport / efficiency;
    let charged = Math.min(input.annualExport, maximumAnnualCharge, profileLimitedCharge, importLimitedCharge);
    let delivered = Math.min(input.annualImport, charged * efficiency);
    charged = delivered / efficiency;

    const newImport = Math.max(0, input.annualImport - delivered);
    const newExport = Math.max(0, input.annualExport - charged);
    const energyCharge = newImport * input.futureTariff;
    const exportCredit = newExport * input.futureCompensation;
    const returnCharge = newExport * input.futureReturnCosts;
    const cost = energyCharge - exportCredit + returnCharge;
    const benefit = futureScenario.cost - cost;

    return Object.assign({}, product, {
      capacity: capacity,
      charged: charged,
      delivered: delivered,
      newImport: newImport,
      newExport: newExport,
      energyCharge: energyCharge,
      exportCredit: exportCredit,
      returnCharge: returnCharge,
      cost: cost,
      benefit: benefit
    });
  }

  function calculateAdvicePotential(result, assumptions) {
    if (!result || !result.input || !result.future || !result.recommended) {
      return {
        currentSaving: 0,
        potentialSaving: 0,
        rawPotential: 0,
        optimizedBatteryBenefit: 0,
        smartPriceBenefit: 0,
        optimizedDelivered: 0
      };
    }

    const input = result.input;
    const currentSaving = Math.max(0, finiteOr(result.recommended.benefit, 0));
    const optimizedCycles = Math.max(0, finiteOr(assumptions.adviceOptimizedCycles, 300));
    const optimizedProfileFactor = clamp(finiteOr(assumptions.adviceExportUtilization, 0.95), 0, 1);
    const smartValuePerKwh = Math.max(0, finiteOr(assumptions.adviceSmartValuePerKwh, 0.10));
    const optimized = simulateBattery(
      input,
      Object.assign({}, assumptions, {
        cycles: optimizedCycles,
        profileFactor: optimizedProfileFactor
      }),
      result.future,
      result.recommended
    );
    const optimizedBatteryBenefit = Math.max(0, optimized.benefit);
    const smartPriceBenefit = Math.max(0, optimized.delivered * smartValuePerKwh);
    const rawPotential = Math.max(currentSaving, optimizedBatteryBenefit + smartPriceBenefit);
    const roundedPotential = rawPotential > 0.5 ? Math.ceil(rawPotential / 10) * 10 : 0;

    return {
      currentSaving: currentSaving,
      potentialSaving: Math.max(Math.ceil(currentSaving), roundedPotential),
      rawPotential: rawPotential,
      optimizedBatteryBenefit: optimizedBatteryBenefit,
      smartPriceBenefit: smartPriceBenefit,
      optimizedCharged: optimized.charged,
      optimizedDelivered: optimized.delivered,
      optimizedCycles: optimizedCycles,
      optimizedProfileFactor: optimizedProfileFactor,
      smartValuePerKwh: smartValuePerKwh
    };
  }

  function buildYearlySavings(annualSaving, years, growthRate, startYear) {
    const base = Math.max(0, finiteOr(annualSaving, 0));
    const count = Math.max(0, Math.floor(finiteOr(years, 10)));
    const rate = clamp(finiteOr(growthRate, 0), 0, 0.2);
    const firstYear = Math.floor(finiteOr(startYear, 2027));
    return Array.from({ length: count }, (_, index) => ({
      index: index + 1,
      year: firstYear + index,
      value: base * Math.pow(1 + rate, index)
    }));
  }

  function projectSavingsWithGrowth(annualSaving, years, growthRate) {
    return buildYearlySavings(annualSaving, years, growthRate, 2027).reduce((sum, entry) => sum + entry.value, 0);
  }

  function recommendCapacity(simulations, assumptions) {
    const ordered = simulations.slice().sort((a, b) => a.capacity - b.capacity);
    const available = ordered.filter((item) => item.available !== false);
    const candidates = available.length ? available : ordered;
    const smallest = candidates[0] || null;
    const maxBenefit = candidates.reduce((maximum, item) => Math.max(maximum, item.benefit), Number.NEGATIVE_INFINITY);

    candidates.forEach((item) => {
      item.benefitShare = maxBenefit > 0 ? Math.max(0, item.benefit) / maxBenefit : 0;
    });

    if (!smallest) {
      return { item: null, status: 'unavailable', maxBenefit: 0, lowBenefit: true };
    }

    if (!(maxBenefit > 0)) {
      return { item: smallest, status: 'no-positive-effect', maxBenefit: maxBenefit, lowBenefit: true };
    }

    const threshold = clamp(finiteOr(assumptions.recommendationThreshold, 0.85), 0.5, 1);
    const selected = candidates.find((item) => item.benefitShare >= threshold) || candidates[candidates.length - 1];
    const minimumBenefit = Math.max(0, finiteOr(assumptions.minimumBenefit, 100));
    return {
      item: selected,
      status: maxBenefit < minimumBenefit ? 'limited-effect' : 'positive-effect',
      maxBenefit: maxBenefit,
      lowBenefit: maxBenefit < minimumBenefit
    };
  }

  function buildTenYearProjection(annualChange) {
    return Array.from({ length: 10 }, (_, index) => ({
      year: 2027 + index,
      value: annualChange * (index + 1)
    }));
  }

  function evaluateSalderingscheck(input, assumptions, products) {
    const current = calculateCurrentScenario(input);
    const future = calculateFutureScenario(input);
    const simulations = products.map((product) => simulateBattery(input, assumptions, future, product));
    const recommendation = recommendCapacity(simulations, assumptions);
    const recommended = recommendation.item || {
      capacity: 4,
      configuration: '1 × Core',
      delivered: 0,
      charged: 0,
      newImport: input.annualImport,
      newExport: input.annualExport,
      cost: future.cost,
      benefit: 0,
      benefitShare: 0,
      url: '/products/zinvolt-core',
      image: ''
    };
    const annualChange = future.cost - current.cost;
    const tenYear = buildTenYearProjection(annualChange);
    const yearlySavings = buildYearlySavings(
      Math.max(0, recommended.benefit),
      10,
      assumptions.savingsGrowthRate,
      2027
    );
    const tenYearSaving = yearlySavings.reduce((sum, entry) => sum + entry.value, 0);

    const result = {
      version: STATE_VERSION,
      calculatedAt: new Date().toISOString(),
      input: input,
      assumptions: assumptions,
      current: current,
      future: future,
      annualChange: annualChange,
      tenYear: tenYear,
      tenYearChange: annualChange * 10,
      yearlySavings: yearlySavings,
      tenYearSaving: tenYearSaving,
      simulations: simulations,
      recommendation: recommendation,
      recommended: recommended
    };
    result.advicePotential = calculateAdvicePotential(result, assumptions);
    return result;
  }

  function describePlans(plans) {
    if (!Array.isArray(plans) || !plans.length) return 'Geen';
    return plans.map((plan) => PLAN_LABELS[plan]).filter(Boolean).join(', ') || 'Geen';
  }

  function describeRateMode(mode) {
    return mode === 'custom' ? 'Eigen tarieven' : 'Standaardwaarden';
  }

  function describeChange(value) {
    if (value > 0.5) return formatMoney(Math.abs(value)) + ' meer per jaar';
    if (value < -0.5) return formatMoney(Math.abs(value)) + ' minder per jaar';
    return 'Vrijwel gelijk per jaar';
  }

  function formatAnnualCardValue(value) {
    if (value > 0.5) return formatMoney(Math.abs(value));
    if (value < -0.5) return window.ZinVoltI18n.t("amount_less_a4fa51", {amount:formatMoney(Math.abs(value))});
    return window.ZinVoltI18n.t("almost_unchanged_b9fecf");
  }

  function formatCumulativeCardValue(value) {
    if (value > 0.5) return formatMoney(Math.abs(value));
    if (value < -0.5) return window.ZinVoltI18n.t("amount_less_a4fa51", {amount:formatMoney(Math.abs(value))});
    return window.ZinVoltI18n.t("almost_unchanged_b9fecf");
  }

  function describeDirection(value) {
    if (value > 0.5) return 'increase';
    if (value < -0.5) return 'decrease';
    return 'stable';
  }

  function sanitizeStoredState(state) {
    if (!state || ![4, 5, STATE_VERSION].includes(state.version) || !state.input || typeof state.input !== 'object') return null;
    const source = state.input;
    const input = {};
    ['annualImport', 'annualExport', 'annualGeneration', 'currentTariff', 'currentExcessCompensation', 'futureTariff', 'futureCompensation', 'futureReturnCosts'].forEach((name) => {
      const value = parseLocaleNumber(source[name]);
      input[name] = Number.isFinite(value) ? value : Number.NaN;
    });
    const storedCurrentReturnCosts = parseLocaleNumber(source.currentReturnCosts);
    if (state.version === STATE_VERSION) {
      input.currentReturnCosts = Number.isFinite(storedCurrentReturnCosts) ? storedCurrentReturnCosts : Number.NaN;
    } else if (storedCurrentReturnCosts === 0) {
      input.currentReturnCosts = 0;
    } else if (Number.isFinite(storedCurrentReturnCosts) && Number.isFinite(input.annualExport) && input.annualExport > 0) {
      // V4/V5 stored this value as a fixed annual amount. Preserve the same
      // annual charge when restoring a custom-rate calculation in V6.
      input.currentReturnCosts = storedCurrentReturnCosts / input.annualExport;
    } else {
      input.currentReturnCosts = Number.NaN;
    }
    input.contractType = Object.prototype.hasOwnProperty.call(CONTRACT_LABELS, source.contractType) ? source.contractType : 'fixed';
    input.rateMode = source.rateMode === 'custom' ? 'custom' : 'average';
    input.profile = Object.prototype.hasOwnProperty.call(PROFILE_LABELS, source.profile) ? source.profile : 'evening';
    input.plans = Array.isArray(source.plans) ? source.plans.filter((plan) => Object.prototype.hasOwnProperty.call(PLAN_LABELS, plan)) : [];

    return {
      version: STATE_VERSION,
      input: input,
      currentStep: clamp(finiteOr(state.currentStep, 1), 1, 4),
      contactMethod: 'callback',
      contactName: typeof state.contactName === 'string' ? state.contactName : '',
      contactPhone: typeof state.contactPhone === 'string' ? state.contactPhone : '',
      contactEmail: typeof state.contactEmail === 'string' ? state.contactEmail : '',
      // Results from an older formula are always recalculated after restore.
      lastResult: state.version === STATE_VERSION ? (state.lastResult || null) : null
    };
  }

  function buildContactBody(result, contact) {
    const input = result.input;
    const advicePotential = result.advicePotential || calculateAdvicePotential(result, result.assumptions || {});
    const savingsGrowthRate = clamp(finiteOr(result.assumptions && result.assumptions.savingsGrowthRate, 0.025), 0, 0.2);
    const tenYearSaving = Array.isArray(result.yearlySavings) && result.yearlySavings.length === 10
      ? result.yearlySavings.reduce((sum, entry) => sum + finiteOr(entry && entry.value, 0), 0)
      : projectSavingsWithGrowth(result.recommended.benefit, 10, savingsGrowthRate);
    const lines = [
      'Nieuwe telefonische adviesaanvraag via de Salderingscheck 2027',
      '',
      'Contactvoorkeur:',
      'Telefonisch terugbellen',
      '',
      'Naam:',
      contact.name,
      '',
      'Telefoonnummer:',
      contact.phone,
      '',
      'Ingevulde gegevens:',
      '',
      'Energiecontract:',
      CONTRACT_LABELS[input.contractType] || 'Onbekend',
      '',
      'Netafname:',
      formatKwhBackend(input.annualImport) + ' per jaar',
      '',
      'Teruglevering:',
      formatKwhBackend(input.annualExport) + ' per jaar',
      '',
      'Zonneopwek:',
      formatKwhBackend(input.annualGeneration) + ' per jaar',
      '',
      'Direct eigen verbruik:',
      formatKwhBackend(result.current.directUse) + ' per jaar',
      '',
      'Verbruiksprofiel:',
      PROFILE_LABELS[input.profile] || 'Onbekend',
      '',
      'Toekomstplannen:',
      describePlans(input.plans),
      '',
      'Rekenmethode:',
      describeRateMode(input.rateMode),
      '',
      'Gebruikte tarieven:',
      '2026 stroomtarief ' + formatMoneyPreciseBackend(input.currentTariff) + ' per kWh; vergoeding overschot ' + formatMoneyPreciseBackend(input.currentExcessCompensation) + ' per kWh; terugleverkosten ' + formatMoneyPreciseBackend(input.currentReturnCosts) + ' per teruggeleverde kWh (' + formatMoneyPreciseBackend(result.current.returnCharge) + ' per jaar bij ' + formatKwhBackend(input.annualExport) + ').',
      '2027 stroomtarief ' + formatMoneyPreciseBackend(input.futureTariff) + ' per kWh; terugleververgoeding ' + formatMoneyPreciseBackend(input.futureCompensation) + ' per kWh; terugleverkosten ' + formatMoneyPreciseBackend(input.futureReturnCosts) + ' per teruggeleverde kWh.',
      '',
      'Eerste indicatie:',
      '',
      'Berekende verandering vanaf 2027:',
      describeChangeBackend(result.annualChange),
      '',
      'Mogelijke batterijbesparing over 10 jaar:',
      formatMoneyBackend(tenYearSaving) + ' bij een jaarlijkse rekenaanname van ' + formatPercentageBackend(savingsGrowthRate),
      '',
      'Indicatieve batterijcapaciteit:',
      'ZinVolt Core ' + numberFormatterBackend.format(result.recommended.capacity) + ' kWh',
      '',
      'Geschatte stroom uit batterij:',
      formatKwhBackend(result.recommended.delivered) + ' per jaar',
      '',
      'Geschatte batterijbesparing:',
      formatMoneyBackend(Math.max(0, result.recommended.benefit)) + ' per jaar',
      '',
      'Berekende maximale ruimte met persoonlijk advies:',
      advicePotential.potentialSaving > 0 ? 'Tot ' + formatMoneyBackend(advicePotential.potentialSaving) + ' per jaar; indicatieve bovengrens, persoonlijk te toetsen en geen garantie.' : 'Persoonlijk te bepalen; geen garantie.',
      '',
      'Pagina:',
      window.location.href.split('#')[0]
    ];
    return lines.join('\n');
  }

  function validateCallbackContactValues(nameValue, phoneValue, emailValue) {
    const name = String(nameValue || '').trim();
    const phone = String(phoneValue || '').trim();
    const email = String(emailValue || '').trim();
    const phoneDigits = phone.replace(/\D/g, '');
    const invalidName = name.length < 2;
    const invalidPhone = phoneDigits.length < 8 || phoneDigits.length > 15;
    const invalidEmail = Boolean(email) && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    const errors = [];
    if (invalidName) errors.push(window.ZinVoltI18n.t("enter_your_name_0f9e16"));
    if (invalidPhone) errors.push(window.ZinVoltI18n.t("enter_a_valid_phone_number_377c8b"));
    if (invalidEmail) errors.push(window.ZinVoltI18n.t("enter_a_valid_email_address_or_leave_41e137"));
    return {
      name,
      phone,
      email,
      invalidName,
      invalidPhone,
      invalidEmail,
      valid: !invalidName && !invalidPhone && !invalidEmail,
      errors
    };
  }

  window.ZVSalderingscheckMath = {
    parseLocaleNumber: parseLocaleNumber,
    collectInput: collectInput,
    validateInput: validateInput,
    calculateCurrentScenario: calculateCurrentScenario,
    calculateFutureScenario: calculateFutureScenario,
    simulateBattery: simulateBattery,
    calculateAdvicePotential: calculateAdvicePotential,
    projectSavingsWithGrowth: projectSavingsWithGrowth,
    buildYearlySavings: buildYearlySavings,
    recommendCapacity: recommendCapacity,
    buildTenYearProjection: buildTenYearProjection,
    buildContactBody: buildContactBody,
    validateCallbackContactValues: validateCallbackContactValues,
    sanitizeStoredState: sanitizeStoredState,
    evaluateSalderingscheck: evaluateSalderingscheck
  };

  class Salderingscheck {
    constructor(root) {
      this.root = root;
      this.form = root.querySelector('.zv-sc__form');
      this.formState = root.querySelector('[data-zv-sc-form-state]');
      this.steps = Array.from(root.querySelectorAll('[data-zv-sc-step]'));
      this.navigation = root.querySelector('[data-zv-sc-navigation]');
      this.workspace = root.querySelector('.zv-sc__workspace');
      this.contactSection = root.querySelector('.zv-sc__contact');
      this.callbackFormContent = root.querySelector('[data-zv-sc-callback-form-content]');
      this.callbackSuccess = root.querySelector('[data-zv-sc-callback-success]');
      this.contactErrorBox = root.querySelector('[data-zv-sc-contact-error]');
      this.callbackSubmitButton = root.querySelector('[data-zv-sc-callback-submit]');
      this.nextButton = root.querySelector('[data-zv-sc-next]');
      this.backButton = root.querySelector('[data-zv-sc-back]');
      this.errorBox = root.querySelector('[data-zv-sc-error]');
      this.warningBox = root.querySelector('[data-zv-sc-warning]');
      this.progress = root.querySelector('[data-zv-sc-progress]');
      this.progressElement = root.querySelector('.zv-sc__progress');
      this.stepCount = root.querySelector('[data-zv-sc-step-count]');
      this.stepTitle = root.querySelector('[data-zv-sc-step-title]');
      this.stepDescription = root.querySelector('[data-zv-sc-step-description]');
      this.stepDots = Array.from(root.querySelectorAll('.zv-sc__step-dots li'));
      this.tooltip = root.querySelector('[data-zv-sc-tooltip]');
      this.productDataElement = root.querySelector('[data-zv-sc-product-data]');
      this.currentStep = 1;
      this.lastResult = null;
      this.contactMethod = 'callback';
      this.callbackSubmitting = false;
      this.resultViewTracked = false;
      this.leadStarted = false;
      this.viewedSteps = new Set();
      this.storageKey = 'zvSalderingscheckV6:' + (root.dataset.sectionId || 'default');
      this.legacyStorageKeys = ['zvSalderingscheckV5:', 'zvSalderingscheckV4:'].map((prefix) => prefix + (root.dataset.sectionId || 'default'));
      this.contactPendingKey = 'zvSalderingscheckContactPending:' + (root.dataset.sectionId || 'default');
      this.reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.defaults = this.readDefaults();
      this.assumptions = this.readAssumptions();
      this.products = this.readProducts();
      this.savedState = this.readState();
    }

    readDefaults() {
      return {
        currentTariff: finiteOr(this.root.dataset.defaultCurrentTariff, 0.3),
        currentExcessCompensation: finiteOr(this.root.dataset.defaultCurrentExcess, 0.06),
        currentReturnCosts: finiteOr(this.root.dataset.defaultCurrentReturnCosts, 0.06),
        futureTariff: finiteOr(this.root.dataset.defaultFutureTariff, 0.3),
        futureCompensation: finiteOr(this.root.dataset.defaultFutureCompensation, 0.06),
        futureReturnCosts: finiteOr(this.root.dataset.defaultFutureReturnCosts, 0.05)
      };
    }

    readAssumptions() {
      return {
        efficiency: clamp(finiteOr(this.root.dataset.batteryEfficiency, 0.9), 0.01, 1),
        cycles: Math.max(0, finiteOr(this.root.dataset.batteryCycles, 220)),
        recommendationThreshold: clamp(finiteOr(this.root.dataset.recommendationThreshold, 0.85), 0.5, 1),
        minimumBenefit: Math.max(0, finiteOr(this.root.dataset.minimumBenefit, 100)),
        adviceOptimizedCycles: Math.max(0, finiteOr(this.root.dataset.adviceOptimizedCycles, 300)),
        adviceExportUtilization: clamp(finiteOr(this.root.dataset.adviceExportUtilization, 0.95), 0, 1),
        adviceSmartValuePerKwh: Math.max(0, finiteOr(this.root.dataset.adviceSmartValue, 0.10)),
        savingsGrowthRate: clamp(finiteOr(this.root.dataset.savingsGrowthRate, 0.025), 0, 0.2)
      };
    }

    readProducts() {
      let products = [];
      try {
        products = JSON.parse(this.productDataElement ? this.productDataElement.textContent : '[]');
      } catch (error) {
        products = [];
      }
      if (!Array.isArray(products) || !products.length) {
        products = [4, 8, 12, 16].map((capacity, index) => ({
          capacity: capacity,
          available: true,
          configuration: index === 0 ? '1 × Core' : 'Core + ' + index + (index === 1 ? ' Link' : ' Link-modules'),
          url: (this.root.dataset.coreUrl || '/products/zinvolt-core'),
          image: ''
        }));
      }
      return products.map((product) => ({
        capacity: finiteOr(product.capacity, 4),
        available: product.available !== false,
        configuration: String(product.configuration || ''),
        url: String(product.url || this.root.dataset.coreUrl || '/products/zinvolt-core'),
        image: String(product.image || '')
      })).sort((a, b) => a.capacity - b.capacity);
    }

    init() {
      if (!this.form) return;
      this.form.noValidate = true;
      document.body.classList.add('zv-sc-page-mode');
      this.fillDefaultRateFields();
      this.restoreStateToForm();
      this.bindEvents();
      this.syncChoiceCards();
      this.syncRateMode();
      this.setupTooltips();
      this.updateContactButtonStates();

      const serverPostedSuccess = this.formState && this.formState.dataset.postedSuccess === 'true';
      const queryPostedSuccess = new URLSearchParams(window.location.search).get('contact_posted') === 'true';
      const postedSuccess = serverPostedSuccess || (queryPostedSuccess && this.hasPendingContact());
      const hasErrors = this.formState && this.formState.dataset.hasErrors === 'true';
      const restoredResult = this.recalculateRestoredResult();

      if (queryPostedSuccess && !postedSuccess) this.clearPostedSuccessQuery();

      if (postedSuccess) {
        this.lastResult = restoredResult;
        this.contactMethod = 'callback';
        this.setContactMethod('callback', false);
        this.goToStep(4, { scroll: false, render: Boolean(restoredResult) });
        this.showCallbackSuccess();
        this.clearStoredContactAfterSuccess();
        // Funnel/UX only. The Forms bridge owns the canonical conversion event.
        this.track('zv_sc_callback_success', { contact_method: 'callback' });
      } else if (hasErrors && restoredResult) {
        this.setPendingContact(false);
        this.lastResult = restoredResult;
        this.contactMethod = 'callback';
        this.setContactMethod('callback', false);
        this.goToStep(4, { scroll: false, render: true });
      } else if (this.savedState && this.savedState.currentStep === 4 && restoredResult) {
        this.lastResult = restoredResult;
        this.goToStep(4, { scroll: false, render: true });
        this.setContactMethod(this.savedState.contactMethod || 'callback', false);
      } else {
        const savedStep = this.savedState ? clamp(finiteOr(this.savedState.currentStep, 1), 1, 3) : 1;
        this.goToStep(savedStep, { scroll: false, render: false });
      }

      if (!this.savedState) this.track('zv_sc_start', { step_number: 1 });
    }

    fillDefaultRateFields() {
      Object.keys(this.defaults).forEach((name) => {
        const input = this.form.elements.namedItem(name);
        if (input && !String(input.value || '').trim()) input.value = this.defaults[name];
      });
    }

    restoreStateToForm() {
      if (!this.savedState || !this.savedState.input) return;
      const input = this.savedState.input;
      ['annualImport', 'annualExport', 'annualGeneration'].forEach((name) => {
        const field = this.form.elements.namedItem(name);
        if (field && Number.isFinite(input[name])) field.value = input[name];
      });
      ['currentTariff', 'currentExcessCompensation', 'currentReturnCosts', 'futureTariff', 'futureCompensation', 'futureReturnCosts'].forEach((name) => {
        const field = this.form.elements.namedItem(name);
        if (field && input.rateMode === 'custom' && Number.isFinite(input[name])) field.value = input[name];
      });
      const contractType = Object.prototype.hasOwnProperty.call(CONTRACT_LABELS, input.contractType) ? input.contractType : 'fixed';
      const rateMode = input.rateMode === 'custom' ? 'custom' : 'average';
      const profile = Object.prototype.hasOwnProperty.call(PROFILE_LABELS, input.profile) ? input.profile : 'evening';
      this.checkRadio('contractType', contractType);
      this.checkRadio('rateMode', rateMode);
      this.checkRadio('usageProfile', profile);
      const plans = Array.isArray(input.plans) ? input.plans.filter((plan) => Object.prototype.hasOwnProperty.call(PLAN_LABELS, plan)) : [];
      this.form.querySelectorAll('input[name="futurePlans"]').forEach((field) => {
        field.checked = plans.includes(field.value);
      });

      const callbackName = this.form.querySelector('[data-zv-sc-contact-name]');
      const callbackPhone = this.form.querySelector('[data-zv-sc-contact-phone]');
      const callbackEmail = this.form.querySelector('[data-zv-sc-contact-email]');
      if (callbackName && !callbackName.value) callbackName.value = this.savedState.contactName || '';
      if (callbackPhone && !callbackPhone.value) callbackPhone.value = this.savedState.contactPhone || '';
      if (callbackEmail && !callbackEmail.value) callbackEmail.value = this.savedState.contactEmail || '';
      this.contactMethod = 'callback';
    }

    checkRadio(name, value) {
      if (!value) return;
      const field = Array.from(this.form.querySelectorAll('input[name="' + name + '"]')).find((candidate) => candidate.value === String(value));
      if (field) field.checked = true;
    }

    recalculateRestoredResult() {
      const input = collectInput(this.form, this.defaults);
      const validation = validateInput(input, 3);
      if (!validation.valid) return null;
      return evaluateSalderingscheck(input, this.assumptions, this.products);
    }

    bindEvents() {
      if (this.nextButton) this.nextButton.addEventListener('click', () => this.handleNext());
      if (this.backButton) {
        this.backButton.addEventListener('click', () => {
          this.track('zv_sc_step_back', { step_number: this.currentStep });
          this.goToStep(Math.max(1, this.currentStep - 1), { scroll: true, render: false });
        });
      }
      const exampleButton = this.root.querySelector('[data-zv-sc-example]');
      if (exampleButton) exampleButton.addEventListener('click', () => this.useExampleValues());
      const editButton = this.root.querySelector('[data-zv-sc-edit]');
      if (editButton) {
        editButton.addEventListener('click', () => {
          this.track('zv_sc_edit_input', { step_number: 4 });
          this.goToStep(1, { scroll: true, render: false });
        });
      }

      this.root.querySelectorAll('[data-zv-sc-product-link]').forEach((productLink) => {
        productLink.addEventListener('click', () => {
          this.track('zv_sc_product_click', {
            recommended_capacity: this.lastResult ? this.lastResult.recommended.capacity : null
          });
        });
      });

      const resultAdviceButton = this.root.querySelector('[data-zv-sc-result-advice]');
      if (resultAdviceButton) {
        resultAdviceButton.addEventListener('click', () => {
          this.track('zv_sc_result_advice_click', {
            recommended_capacity: this.lastResult ? this.lastResult.recommended.capacity : null
          });
          if (!this.contactSection) return;
          this.contactSection.classList.add('is-cro-highlight');
          this.contactSection.scrollIntoView({ block: 'start', behavior: this.reducedMotion ? 'auto' : 'smooth' });
          const heading = this.contactSection.querySelector('[data-zv-sc-contact-heading]');
          window.setTimeout(() => {
            if (heading) heading.focus({ preventScroll: true });
          }, this.reducedMotion ? 0 : 320);
          window.setTimeout(() => this.contactSection.classList.remove('is-cro-highlight'), 1800);
        });
      }

      const restartButton = this.root.querySelector('[data-zv-sc-restart]');
      if (restartButton) restartButton.addEventListener('click', () => this.restartCheck());

      [
        this.root.querySelector('[data-zv-sc-contact-name]'),
        this.root.querySelector('[data-zv-sc-contact-phone]'),
        this.root.querySelector('[data-zv-sc-contact-email]')
      ].filter(Boolean).forEach((field) => {
        field.addEventListener('input', () => this.refreshContactValidation());
      });

      this.form.addEventListener('change', (event) => this.handleFormChange(event));
      this.form.addEventListener('input', () => {
        this.saveState();
        this.syncStepValidity();
      });
      this.form.addEventListener('keydown', (event) => this.handleContactKeydown(event));
      this.form.addEventListener('submit', (event) => this.handleCallbackSubmit(event), true);

      if (this.contactSection) {
        this.contactSection.addEventListener('focusin', () => this.trackLeadStart());
        this.contactSection.addEventListener('input', () => this.trackLeadStart());
      }
      const method = this.root.querySelector('.zv-sc__method');
      if (method) {
        let methodTracked = false;
        method.addEventListener('toggle', () => {
          if (!method.open || methodTracked) return;
          methodTracked = true;
          this.track('zv_sc_method_open', { step_number: this.currentStep });
        });
      }
      this.root.addEventListener('wheel', (event) => this.forwardResultWheel(event), { passive: false });
    }

    handleFormChange(event) {
      const target = event.target;
      if (!(target instanceof HTMLInputElement)) return;
      if (target.name === 'contactMethod') {
        this.setContactMethod(target.value, true);
        return;
      }
      if (target.name === 'rateMode') this.syncRateMode();
      if (target.name === 'contractType') this.syncDynamicRateLabels();
      this.syncChoiceCards();
      this.saveState();
      this.syncStepValidity();
    }

    handleContactKeydown(event) {
      const target = event.target;
      if (!(target instanceof HTMLInputElement) || target.name !== 'contactMethod') return;
      if (!['ArrowRight', 'ArrowDown', 'ArrowLeft', 'ArrowUp'].includes(event.key)) return;
      const fields = Array.from(this.form.querySelectorAll('input[name="contactMethod"]'));
      const currentIndex = fields.indexOf(target);
      if (currentIndex < 0 || fields.length < 2) return;
      event.preventDefault();
      const direction = event.key === 'ArrowRight' || event.key === 'ArrowDown' ? 1 : -1;
      const next = fields[(currentIndex + direction + fields.length) % fields.length];
      next.checked = true;
      this.setContactMethod(next.value, true);
      next.focus();
    }

    syncChoiceCards() {
      this.root.querySelectorAll('.zv-sc__choice-card, .zv-sc__mode-card, .zv-sc__profile-card, [data-zv-sc-contact-choice]').forEach((card) => {
        const input = card.querySelector('input');
        card.classList.toggle('is-selected', Boolean(input && input.checked));
      });
    }

    syncRateMode() {
      const mode = getCheckedValue(this.form, 'rateMode', 'average');
      const custom = this.root.querySelector('[data-zv-sc-custom-rates]');
      if (custom) custom.hidden = mode !== 'custom';
      this.syncDynamicRateLabels();
    }

    syncDynamicRateLabels() {
      const dynamic = getCheckedValue(this.form, 'contractType', '') === 'dynamic';
      const labels = {
        currentTariff: dynamic ? window.ZinVoltI18n.t("average_current_electricity_rate_c1cdea") : window.ZinVoltI18n.t("current_electricity_rate_70acf1"),
        currentExcessCompensation: dynamic ? window.ZinVoltI18n.t("average_compensation_for_surplus_grid_export_89039c") : window.ZinVoltI18n.t("compensation_for_surplus_grid_export_5df315"),
        futureTariff: dynamic ? window.ZinVoltI18n.t("average_electricity_rate_for_2027_c0b0eb") : window.ZinVoltI18n.t("electricity_rate_for_2027_7aec35"),
        futureCompensation: dynamic ? window.ZinVoltI18n.t("average_feed_in_compensation_for_2027_7677b6") : window.ZinVoltI18n.t("feed_in_compensation_for_2027_406426")
      };
      Object.keys(labels).forEach((name) => {
        const element = this.root.querySelector('[data-zv-sc-rate-label="' + name + '"]');
        if (element) element.textContent = labels[name];
      });
    }

    useExampleValues() {
      const values = { annualImport: 2600, annualExport: 2100, annualGeneration: 3200 };
      Object.keys(values).forEach((name) => {
        const field = this.form.elements.namedItem(name);
        if (field) field.value = values[name];
      });
      this.showMessages([], []);
      this.saveState();
      this.syncStepValidity();
      this.track('zv_sc_example_values', { step_number: 1 });
    }

    syncStepValidity() {
      const isInteractiveStep = this.currentStep < 4;
      const ready =
        isInteractiveStep && validateInput(collectInput(this.form, this.defaults), this.currentStep).valid;
      this.root.dataset.currentStep = String(this.currentStep);
      this.root.dataset.stepValid = ready ? 'true' : 'false';
      this.root.classList.toggle('is-mobile-nav-ready', isInteractiveStep);
      if (this.navigation) this.navigation.classList.toggle('is-mobile-ready', isInteractiveStep);
    }

    handleNext() {
      const input = collectInput(this.form, this.defaults);
      const validation = validateInput(input, this.currentStep);
      this.clearInvalidState();
      this.showMessages(validation.errors, validation.warnings);
      if (!validation.valid) {
        this.focusFirstProblem(input, this.currentStep);
        return;
      }

      if (this.currentStep < 3) {
        const completedStep = this.currentStep;
        this.track('zv_sc_step_complete', { step_number: completedStep, step_name: STEP_SLUGS[completedStep - 1] });
        this.goToStep(completedStep + 1, { scroll: true, render: false });
        return;
      }

      this.track('zv_sc_step_complete', { step_number: 3, step_name: STEP_SLUGS[2] });
      this.lastResult = evaluateSalderingscheck(input, this.assumptions, this.products);
      this.resultViewTracked = false;
      this.contactMethod = 'callback';
      this.setContactMethod('callback', false);
      this.goToStep(4, { scroll: true, render: true });
    }

    clearInvalidState() {
      this.form.querySelectorAll('[aria-invalid="true"]').forEach((field) => field.removeAttribute('aria-invalid'));
    }

    focusFirstProblem(input, throughStep) {
      const invalidNumber = (value, minimum, maximum) => !Number.isFinite(value) || value < minimum || value > maximum;
      let field = null;

      if (throughStep >= 1) {
        ['annualImport', 'annualExport', 'annualGeneration'].some((name) => {
          if (!invalidNumber(input[name], 0, 50000)) return false;
          field = this.form.elements.namedItem(name);
          return true;
        });
      }

      if (!field && throughStep >= 2 && !Object.prototype.hasOwnProperty.call(CONTRACT_LABELS, input.contractType)) {
        field = this.form.querySelector('input[name="contractType"]');
      }

      if (!field && throughStep >= 2 && input.rateMode === 'custom') {
        [
          ['currentTariff', 0, 2],
          ['currentExcessCompensation', 0, 2],
          ['currentReturnCosts', 0, 2],
          ['futureTariff', 0, 2],
          ['futureCompensation', 0, 2],
          ['futureReturnCosts', 0, 2]
        ].some((entry) => {
          if (!invalidNumber(input[entry[0]], entry[1], entry[2])) return false;
          field = this.form.elements.namedItem(entry[0]);
          return true;
        });
      }

      if (!field && throughStep >= 3 && !Object.prototype.hasOwnProperty.call(PROFILE_LABELS, input.profile)) {
        field = this.form.querySelector('input[name="usageProfile"]');
      }

      if (!field || typeof field.focus !== 'function') return;
      field.setAttribute('aria-invalid', 'true');
      field.focus({ preventScroll: true });
      if (typeof field.scrollIntoView === 'function') {
        field.scrollIntoView({ block: 'center', behavior: this.reducedMotion ? 'auto' : 'smooth' });
      }
    }

    goToStep(step, options) {
      const settings = options || {};
      this.currentStep = clamp(Number(step) || 1, 1, 4);
      this.steps.forEach((section) => {
        const active = Number(section.dataset.zvScStep) === this.currentStep;
        section.hidden = !active;
        section.classList.toggle('is-active', active);
      });

      if (this.navigation) this.navigation.hidden = this.currentStep === 4;
      if (this.backButton) this.backButton.hidden = this.currentStep === 1 || this.currentStep === 4;
      if (this.nextButton) {
        const label = this.nextButton.querySelector('span');
        if (label) label.textContent = this.currentStep === 3 ? window.ZinVoltI18n.t("view_my_estimate_49c43c") : window.ZinVoltI18n.t("continue_94556a");
      }
      this.syncStepValidity();

      if (this.stepTitle) this.stepTitle.textContent = STEP_TITLES[this.currentStep - 1];
      if (this.stepDescription) this.stepDescription.textContent = STEP_DESCRIPTIONS[this.currentStep - 1];
      if (this.stepCount) this.stepCount.textContent = window.ZinVoltI18n.t("step_progress", {current:this.currentStep,total:4});
      if (this.progress) this.progress.style.width = (this.currentStep * 25) + '%';
      if (this.progressElement) this.progressElement.setAttribute('aria-valuenow', String(this.currentStep));
      this.stepDots.forEach((dot, index) => {
        const isActive = index + 1 === this.currentStep;
        dot.classList.toggle('is-active', isActive);
        dot.classList.toggle('is-complete', index + 1 < this.currentStep);
        if (isActive) dot.setAttribute('aria-current', 'step');
        else dot.removeAttribute('aria-current');
      });

      this.root.classList.toggle('is-result', this.currentStep === 4);
      if (this.currentStep === 4 && settings.render !== false && this.lastResult) this.renderResult(this.lastResult);
      if (this.currentStep === 4 && this.lastResult && !this.resultViewTracked) {
        this.track('zv_sc_result_view', {
          step_number: 4,
          usage_profile: this.lastResult.input.profile,
          result_direction: describeDirection(this.lastResult.annualChange)
        });
        this.resultViewTracked = true;
      }
      this.updateStepMeasurement();
      this.saveState();
      this.showMessages([], []);

      if (settings.scroll) {
        window.setTimeout(() => {
          if (window.matchMedia && window.matchMedia('(min-width: 901px)').matches && this.workspace) {
            this.workspace.scrollTo({ top: 0, behavior: this.reducedMotion ? 'auto' : 'smooth' });
            if (this.currentStep === 4) {
              const resultHeading = this.root.querySelector('[data-zv-sc-result-heading]');
              if (resultHeading) resultHeading.focus({ preventScroll: true });
            }
            return;
          }
          const top = Math.max(0, this.root.getBoundingClientRect().top + window.scrollY - 16);
          window.scrollTo({ top: top, behavior: this.reducedMotion ? 'auto' : 'smooth' });
          if (this.currentStep === 4) {
            const resultHeading = this.root.querySelector('[data-zv-sc-result-heading]');
            if (resultHeading) resultHeading.focus({ preventScroll: true });
          }
        }, 40);
      }
    }

    updateStepMeasurement() {
      const stepName = STEP_SLUGS[this.currentStep - 1] || STEP_SLUGS[0];
      let virtualPath = window.location.pathname;
      let pageLocation = window.location.href;
      try {
        const url = new URL(window.location.href);
        url.searchParams.set('stap', stepName);
        url.hash = '';
        virtualPath = url.pathname + url.search;
        pageLocation = url.toString();
        if (window.history && typeof window.history.replaceState === 'function') {
          window.history.replaceState(Object.assign({}, window.history.state || {}, { zvScStep: this.currentStep }), '', pageLocation);
        }
      } catch (error) {
        virtualPath = window.location.pathname + '?stap=' + stepName;
      }
      if (this.viewedSteps.has(this.currentStep)) return;
      this.viewedSteps.add(this.currentStep);
      this.track('zv_sc_step_view', {
        step_number: this.currentStep,
        step_name: stepName,
        virtual_path: virtualPath,
        page_location: pageLocation
      });
    }

    forwardResultWheel(event) {
      if (this.currentStep !== 4 || !this.workspace || event.ctrlKey) return;
      if (!window.matchMedia || !window.matchMedia('(min-width: 901px)').matches) return;
      if (this.workspace.contains(event.target) || !event.deltaY) return;
      const multiplier = event.deltaMode === 1 ? 18 : event.deltaMode === 2 ? this.workspace.clientHeight : 1;
      event.preventDefault();
      this.workspace.scrollTop += event.deltaY * multiplier;
    }

    trackLeadStart() {
      if (this.leadStarted) return;
      this.leadStarted = true;
      this.track('zv_sc_lead_start', { step_number: 4, contact_method: this.contactMethod });
    }

    showMessages(errors, warnings) {
      if (this.errorBox) {
        this.errorBox.hidden = !errors.length;
        this.errorBox.textContent = errors.join(' ');
      }
      if (this.warningBox) {
        this.warningBox.hidden = !warnings.length;
        this.warningBox.textContent = warnings.join(' ');
      }
    }

    renderResult(result) {
      const savingsGrowthRate = clamp(finiteOr(this.assumptions.savingsGrowthRate, 0.025), 0, 0.2);
      const yearlySavings = Array.isArray(result.yearlySavings) && result.yearlySavings.length === 10
        ? result.yearlySavings
        : buildYearlySavings(result.recommended.benefit, 10, savingsGrowthRate, 2027);
      const tenYearSaving = yearlySavings.reduce((sum, entry) => sum + finiteOr(entry && entry.value, 0), 0);
      result.yearlySavings = yearlySavings;
      result.tenYearSaving = tenYearSaving;
      this.setText('[data-zv-sc-annual-label]', result.annualChange > 0.5 ? window.ZinVoltI18n.t("extra_annual_electricity_costs_after_net_metering_1ba304") : window.ZinVoltI18n.t("estimated_annual_change_5ed9d3"));
      this.setText('[data-zv-sc-ten-year-label]', window.ZinVoltI18n.t("potential_savings_over_10_years_53ac76"));
      this.animateChangeValue(this.root.querySelector('[data-zv-sc-annual-change]'), result.annualChange, formatAnnualCardValue);
      this.animateChangeValue(this.root.querySelector('[data-zv-sc-ten-year-change]'), tenYearSaving, formatMoney);
      this.setText('[data-zv-sc-annual-copy]', ANNUAL_CARD_COPY[result.input.contractType] || ANNUAL_CARD_COPY.unknown);
      this.setText('[data-zv-sc-ten-year-copy]', window.ZinVoltI18n.t("2027_2036_annual_calculation_assumption_rate_a509e4", {rate:formatPercentage(savingsGrowthRate)}));
      this.setText('[data-zv-sc-capacity]', numberFormatter.format(result.recommended.capacity) + ' kWh');
      this.renderOptimization(result);
      this.renderPersonalContact(result);
      this.updateContactMessages(result);
      this.saveState();
    }

    renderOptimization(result) {
      const optimization = this.root.querySelector('[data-zv-sc-optimization]');
      const fill = this.root.querySelector('[data-zv-sc-savings-fill]');
      const marker = this.root.querySelector('[data-zv-sc-savings-marker]');
      const advicePotential = result.advicePotential || calculateAdvicePotential(result, this.assumptions);
      const currentSaving = advicePotential.currentSaving;
      const potentialSaving = advicePotential.potentialSaving;
      const hasPotentialAmount = potentialSaving > 0.5;
      const share = potentialSaving > 0 ? clamp(currentSaving / potentialSaving, 0, 1) : 0;
      const sharePercentage = Math.round(share * 10000) / 100;
      const currentLabel = currentSaving > 0.5 ? formatMoney(currentSaving) : formatMoney(0);
      const potentialLabel = hasPotentialAmount ? window.ZinVoltI18n.t("up_to_amount_per_year_12c60f", {amount:formatMoney(potentialSaving)}) : window.ZinVoltI18n.t("to_be_assessed_individually_d200b1");

      result.advicePotential = advicePotential;
      if (optimization) {
        optimization.dataset.status = result.recommendation.status;
        optimization.dataset.hasAdviceAmount = hasPotentialAmount ? 'true' : 'false';
        optimization.style.setProperty('--zv-sc-savings-share', sharePercentage + '%');
      }
      if (fill) fill.style.width = sharePercentage + '%';
      if (marker) {
        marker.style.left = sharePercentage + '%';
        marker.dataset.align = share <= 0.18 ? 'start' : share >= 0.82 ? 'end' : 'center';
      }
      const meter = this.root.querySelector('[data-zv-sc-savings-meter]');
      if (meter) meter.setAttribute('aria-label', window.ZinVoltI18n.t("current_estimate_current_per_year_calculated_maximum_9d898c", {current:currentLabel,potential:potentialLabel}));
      this.setText('[data-zv-sc-optimization-value]', hasPotentialAmount ? window.ZinVoltI18n.t("up_to_amount_9cc512", {amount:formatMoney(potentialSaving)}) : window.ZinVoltI18n.t("after_review_b98618"));
      this.setText('[data-zv-sc-optimization-unit]', hasPotentialAmount ? window.ZinVoltI18n.t("per_year_057bb9") : window.ZinVoltI18n.t("to_be_assessed_individually_501345"));
      this.setText('[data-zv-sc-current-saving]', currentLabel);
      this.setText('[data-zv-sc-current-scale]', currentLabel);
      this.setText('[data-zv-sc-max-scale]', hasPotentialAmount ? formatMoney(potentialSaving) : window.ZinVoltI18n.t("after_review_b98618"));
    }

    renderPersonalContact(result) {
      const needsCaution = result.recommendation && (result.recommendation.lowBenefit || result.recommendation.status === 'no-positive-effect');
      this.setText('[data-zv-sc-contact-heading]', needsCaution ? window.ZinVoltI18n.t("discuss_whether_a_home_battery_suits_your_af533d") : window.ZinVoltI18n.t("have_your_results_reviewed_by_a_specialist_701d05"));
    }

    animateChangeValue(element, value, formatter) {
      if (!element) return;
      const format = typeof formatter === 'function' ? formatter : formatChange;
      const finalText = format(value);
      element.setAttribute('aria-label', finalText);
      element.setAttribute('aria-live', 'off');
      if (this.reducedMotion) {
        element.textContent = finalText;
        return;
      }
      const start = performance.now();
      const duration = 900;
      const tick = (now) => {
        const progress = clamp((now - start) / duration, 0, 1);
        const eased = 1 - Math.pow(1 - progress, 3);
        element.textContent = format(value * eased);
        if (progress < 1) window.requestAnimationFrame(tick);
        else element.textContent = finalText;
      };
      window.requestAnimationFrame(tick);
    }

    updateContactMessages(result) {
      const body = this.root.querySelector('[data-zv-sc-contact-body]');
      if (body) body.value = buildContactBody(result, {
        name: this.root.querySelector('[data-zv-sc-contact-name]')?.value.trim() || '',
        phone: this.root.querySelector('[data-zv-sc-contact-phone]')?.value.trim() || ''
      });
    }

    setContactMethod(method, userInitiated) {
      this.contactMethod = 'callback';
      this.root.querySelectorAll('[data-zv-sc-contact-panel]').forEach((panel) => {
        const active = panel.dataset.zvScContactPanel === this.contactMethod;
        panel.hidden = !active;
        panel.classList.toggle('is-active', active);
      });
      this.root.querySelectorAll('input[name="contactMethod"]').forEach((field) => {
        field.checked = field.value === this.contactMethod;
      });
      this.syncChoiceCards();
      this.saveState();
      this.updateContactButtonStates();
      if (this.contactMethod && userInitiated) {
        this.track('zv_sc_contact_method_select', { contact_method: this.contactMethod });
      }
    }

    async handleCallbackSubmit(event) {
      event.preventDefault();
      if (this.callbackSubmitting) return;
      if (this.currentStep !== 4 || this.contactMethod !== 'callback' || !this.lastResult) return;

      const nameField = this.root.querySelector('[data-zv-sc-contact-name]');
      const phoneField = this.root.querySelector('[data-zv-sc-contact-phone]');
      const emailField = this.root.querySelector('[data-zv-sc-contact-email]');
      const validation = this.validateCallbackContact(nameField, phoneField, emailField);

      if (validation.errors.length) {
        this.setPendingContact(false);
        if (validation.invalidName && nameField) nameField.setAttribute('aria-invalid', 'true');
        if (validation.invalidPhone && phoneField) phoneField.setAttribute('aria-invalid', 'true');
        if (validation.invalidEmail && emailField) emailField.setAttribute('aria-invalid', 'true');
        this.showMessages([], []);
        this.showContactErrors(validation.errors);
        if (validation.invalidName && nameField) nameField.focus();
        else if (validation.invalidPhone && phoneField) phoneField.focus();
        else if (validation.invalidEmail && emailField) emailField.focus();
        return;
      }

      this.clearContactErrors();
      [nameField, phoneField, emailField].filter(Boolean).forEach((field) => field.removeAttribute('aria-invalid'));
      this.populateShopifyCallbackFields(this.lastResult);
      this.saveState({
        contactName: validation.name,
        contactPhone: validation.phone,
        contactEmail: validation.email,
        currentStep: 4
      });

      this.callbackSubmitting = true;
      const submitButton = this.callbackSubmitButton;
      const label = submitButton ? submitButton.querySelector('span') : null;
      const originalLabel = label ? label.textContent : '';
      if (submitButton) {
        submitButton.disabled = true;
        submitButton.setAttribute('aria-busy', 'true');
      }
      if (label) label.textContent = window.ZinVoltI18n.t("sending_your_request_926246");
      this.track('zv_sc_callback_submit', { contact_method: 'callback' });
      this.track('zv_sc_lead_submit', { contact_method: 'callback' });

      try {
        if (!window.ZinVoltShopifyForms || typeof window.ZinVoltShopifyForms.submit !== 'function') {
          throw new Error(window.ZinVoltI18n.t("the_advice_form_could_not_be_loaded_b56aa6"));
        }
        await window.ZinVoltShopifyForms.submit(this.form);
        this.setPendingContact(false);
        this.showCallbackSuccess();
        this.clearStoredContactAfterSuccess();
        // Funnel/UX only. The bridge already emitted exactly one canonical
        // zv_shopify_form_submitted after Shopify confirmed the submission.
        this.track('zv_sc_callback_success', { contact_method: 'callback' });
      } catch (error) {
        const message = error && error.message ? error.message : window.ZinVoltI18n.t("your_request_could_not_be_sent_please_3db7ee");
        this.showContactErrors([message]);
      } finally {
        this.callbackSubmitting = false;
        if (submitButton && !this.callbackSuccess?.hidden) {
          submitButton.removeAttribute('aria-busy');
        } else if (submitButton) {
          submitButton.removeAttribute('aria-busy');
          submitButton.disabled = false;
        }
        if (label && this.callbackSuccess?.hidden) label.textContent = originalLabel || window.ZinVoltI18n.t("request_personal_advice_bc7f87");
        this.updateContactButtonStates();
      }
    }

    setShopifyCallbackField(key, value) {
      const field = this.root.querySelector('[data-zv-sc-shopify-field="' + key + '"]');
      if (field) field.value = value == null ? '' : String(value);
    }

    populateShopifyCallbackFields(result) {
      if (!result || !result.input) return;
      const input = result.input;
      const assumptions = result.assumptions || this.assumptions || {};
      const savingsGrowthRate = clamp(finiteOr(assumptions.savingsGrowthRate, 0.025), 0, 0.2);
      const tenYearSaving = Array.isArray(result.yearlySavings) && result.yearlySavings.length === 10
        ? result.yearlySavings.reduce((sum, entry) => sum + finiteOr(entry && entry.value, 0), 0)
        : projectSavingsWithGrowth(result.recommended.benefit, 10, savingsGrowthRate);

      this.setShopifyCallbackField('contactPreference', 'Telefonisch terugbellen');
      this.setShopifyCallbackField('energyContract', CONTRACT_LABELS[input.contractType] || 'Onbekend');
      this.setShopifyCallbackField('annualImport', formatKwhBackend(input.annualImport) + ' per jaar');
      this.setShopifyCallbackField('annualExport', formatKwhBackend(input.annualExport) + ' per jaar');
      this.setShopifyCallbackField('annualGeneration', formatKwhBackend(input.annualGeneration) + ' per jaar');
      this.setShopifyCallbackField('directUse', formatKwhBackend(result.current.directUse) + ' per jaar');
      this.setShopifyCallbackField('usageProfile', PROFILE_LABELS[input.profile] || 'Onbekend');
      this.setShopifyCallbackField('futurePlans', describePlans(input.plans));
      this.setShopifyCallbackField('rateMode', describeRateMode(input.rateMode));
      this.setShopifyCallbackField('rates2026', 'Stroomtarief ' + formatMoneyPreciseBackend(input.currentTariff) + '/kWh; vergoeding terugleveroverschot ' + formatMoneyPreciseBackend(input.currentExcessCompensation) + '/kWh; terugleverkosten ' + formatMoneyPreciseBackend(input.currentReturnCosts) + ' per teruggeleverde kWh (' + formatMoneyPreciseBackend(result.current.returnCharge) + ' per jaar bij ' + formatKwhBackend(input.annualExport) + ').');
      this.setShopifyCallbackField('rates2027', 'Stroomtarief ' + formatMoneyPreciseBackend(input.futureTariff) + '/kWh; terugleververgoeding ' + formatMoneyPreciseBackend(input.futureCompensation) + '/kWh; terugleverkosten ' + formatMoneyPreciseBackend(input.futureReturnCosts) + ' per teruggeleverde kWh.');
      this.setShopifyCallbackField('change2027', describeChangeBackend(result.annualChange));
      this.setShopifyCallbackField('tenYearSaving', formatMoneyBackend(tenYearSaving) + ' bij een jaarlijkse rekenaanname van ' + formatPercentageBackend(savingsGrowthRate));
      this.setShopifyCallbackField('batteryCapacity', 'ZinVolt Core ' + numberFormatterBackend.format(result.recommended.capacity) + ' kWh');
      this.setShopifyCallbackField('batteryDelivery', formatKwhBackend(result.recommended.delivered) + ' per jaar');
      this.setShopifyCallbackField('currentSaving', formatMoneyBackend(Math.max(0, result.recommended.benefit)) + ' per jaar');
      const advicePotential = result.advicePotential || calculateAdvicePotential(result, assumptions);
      this.setShopifyCallbackField('advicePotential', advicePotential.potentialSaving > 0
        ? 'Tot ' + formatMoneyBackend(advicePotential.potentialSaving) + ' per jaar — indicatieve bovengrens volgens optimalisatiescenario; persoonlijk te toetsen, geen garantie'
        : 'Persoonlijk te bepalen; geen garantie');
    }

    validateCallbackContact(nameField, phoneField, emailField) {
      return validateCallbackContactValues(
        nameField ? nameField.value : '',
        phoneField ? phoneField.value : '',
        emailField ? emailField.value : ''
      );
    }

    updateContactButtonStates() {
      const callbackValidation = this.validateCallbackContact(
        this.root.querySelector('[data-zv-sc-contact-name]'),
        this.root.querySelector('[data-zv-sc-contact-phone]'),
        this.root.querySelector('[data-zv-sc-contact-email]')
      );

      if (this.callbackSubmitButton && !this.callbackSubmitting) {
        this.callbackSubmitButton.disabled = !callbackValidation.valid;
        this.callbackSubmitButton.setAttribute('aria-disabled', callbackValidation.valid ? 'false' : 'true');
      }
    }

    refreshContactValidation() {
      const nameField = this.root.querySelector('[data-zv-sc-contact-name]');
      const phoneField = this.root.querySelector('[data-zv-sc-contact-phone]');
      const emailField = this.root.querySelector('[data-zv-sc-contact-email]');
      const validation = this.validateCallbackContact(nameField, phoneField, emailField);
      this.updateContactButtonStates();
      if (nameField && !validation.invalidName) nameField.removeAttribute('aria-invalid');
      if (phoneField && !validation.invalidPhone) phoneField.removeAttribute('aria-invalid');
      if (emailField && !validation.invalidEmail) emailField.removeAttribute('aria-invalid');
      if (!this.contactErrorBox || this.contactErrorBox.hidden) return;
      if (validation.invalidName && nameField) nameField.setAttribute('aria-invalid', 'true');
      if (validation.invalidPhone && phoneField) phoneField.setAttribute('aria-invalid', 'true');
      if (validation.invalidEmail && emailField) emailField.setAttribute('aria-invalid', 'true');
      if (validation.errors.length) this.showContactErrors(validation.errors);
      else this.clearContactErrors();
    }

    showCallbackSuccess() {
      this.clearContactErrors();
      if (this.callbackFormContent) this.callbackFormContent.hidden = true;
      if (this.callbackSuccess) {
        this.callbackSuccess.hidden = false;
        this.callbackSuccess.setAttribute('tabindex', '-1');
      }
      if (this.contactSection) this.contactSection.classList.add('is-submitted');
      window.requestAnimationFrame(() => {
        if (!this.callbackSuccess) return;
        this.callbackSuccess.focus({ preventScroll: true });
        if (this.workspace && window.matchMedia && window.matchMedia('(min-width: 901px)').matches) {
          const workspaceRect = this.workspace.getBoundingClientRect();
          const successRect = this.callbackSuccess.getBoundingClientRect();
          const target = this.workspace.scrollTop + successRect.top - workspaceRect.top - 24;
          this.workspace.scrollTo({ top: Math.max(0, target), behavior: this.reducedMotion ? 'auto' : 'smooth' });
        } else if (typeof this.callbackSuccess.scrollIntoView === 'function') {
          this.callbackSuccess.scrollIntoView({ block: 'center', behavior: this.reducedMotion ? 'auto' : 'smooth' });
        }
      });
    }

    showContactErrors(errors) {
      if (!this.contactErrorBox) return;
      this.contactErrorBox.textContent = errors.join(' ');
      this.contactErrorBox.hidden = false;
    }

    clearContactErrors() {
      if (!this.contactErrorBox) return;
      this.contactErrorBox.hidden = true;
      this.contactErrorBox.textContent = '';
    }

    hideCallbackSuccess() {
      if (this.callbackFormContent) this.callbackFormContent.hidden = false;
      if (this.callbackSuccess) this.callbackSuccess.hidden = true;
      if (this.contactSection) this.contactSection.classList.remove('is-submitted');
    }

    restartCheck() {
      try {
        [this.storageKey].concat(this.legacyStorageKeys).forEach((key) => window.sessionStorage.removeItem(key));
        window.sessionStorage.removeItem(this.contactPendingKey);
      } catch (error) {
        this.root.dataset.storageUnavailable = 'true';
      }
      this.form.reset();
      this.savedState = null;
      this.lastResult = null;
      this.contactMethod = 'callback';
      this.callbackSubmitting = false;
      this.resultViewTracked = false;
      this.leadStarted = false;
      this.viewedSteps = new Set();
      this.clearContactErrors();
      this.hideCallbackSuccess();
      this.fillDefaultRateFields();
      this.syncChoiceCards();
      this.syncRateMode();
      this.setContactMethod('callback', false);
      this.updateContactButtonStates();
      this.goToStep(1, { scroll: true, render: false });
      const url = new URL(window.location.href);
      url.searchParams.delete('contact_posted');
      url.searchParams.set('stap', STEP_SLUGS[0]);
      window.history.replaceState(Object.assign({}, window.history.state || {}, { zvScStep: 1 }), '', url.pathname + url.search + url.hash);
      this.track('zv_sc_restart', { step_number: 1 });
    }

    setupTooltips() {
      if (!this.tooltip) return;
      let activeTrigger = null;
      let pinned = false;
      const hide = () => {
        this.tooltip.hidden = true;
        activeTrigger = null;
        pinned = false;
        this.root.querySelectorAll('[aria-describedby="' + this.tooltip.id + '"]').forEach((button) => button.removeAttribute('aria-describedby'));
      };
      const show = (button, shouldPin) => {
        this.tooltip.textContent = button.dataset.zvScTip || '';
        this.tooltip.hidden = false;
        activeTrigger = button;
        pinned = Boolean(shouldPin);
        this.root.querySelectorAll('[aria-describedby="' + this.tooltip.id + '"]').forEach((item) => item.removeAttribute('aria-describedby'));
        button.setAttribute('aria-describedby', this.tooltip.id);
        const rect = button.getBoundingClientRect();
        const width = Math.min(300, window.innerWidth - 24);
        this.tooltip.style.width = width + 'px';
        const left = clamp(rect.left + rect.width / 2 - width / 2, 12, window.innerWidth - width - 12);
        this.tooltip.style.left = left + 'px';
        const tooltipHeight = this.tooltip.getBoundingClientRect().height;
        const below = rect.bottom + 10;
        const top = below + tooltipHeight <= window.innerHeight - 12
          ? below
          : Math.max(12, rect.top - tooltipHeight - 10);
        this.tooltip.style.top = top + 'px';
      };
      if (!this.tooltip.id) this.tooltip.id = 'zv-sc-tooltip-' + (this.root.dataset.sectionId || 'default');
      this.root.querySelectorAll('[data-zv-sc-tip]').forEach((button) => {
        button.addEventListener('mouseenter', () => { if (!pinned) show(button, false); });
        button.addEventListener('mouseleave', () => { if (!pinned) hide(); });
        button.addEventListener('focus', () => show(button, false));
        button.addEventListener('blur', () => { if (!pinned) hide(); });
        button.addEventListener('click', (event) => {
          event.stopPropagation();
          if (pinned && activeTrigger === button) hide();
          else show(button, true);
        });
      });
      document.addEventListener('click', hide);
      document.addEventListener('keydown', (event) => { if (event.key === 'Escape') hide(); });
    }

    saveState(overrides) {
      const callbackName = this.root.querySelector('[data-zv-sc-contact-name]');
      const callbackPhone = this.root.querySelector('[data-zv-sc-contact-phone]');
      const callbackEmail = this.root.querySelector('[data-zv-sc-contact-email]');
      const state = Object.assign({
        version: STATE_VERSION,
        input: collectInput(this.form, this.defaults),
        currentStep: this.currentStep,
        contactMethod: this.contactMethod,
        contactName: callbackName ? callbackName.value.trim() : '',
        contactPhone: callbackPhone ? callbackPhone.value.trim() : '',
        contactEmail: callbackEmail ? callbackEmail.value.trim() : '',
        lastResult: this.lastResult
      }, overrides || {});
      try {
        window.sessionStorage.setItem(this.storageKey, JSON.stringify(state));
      } catch (error) {
        this.root.dataset.storageUnavailable = 'true';
      }
    }

    readState() {
      const keys = [this.storageKey].concat(this.legacyStorageKeys);
      for (const key of keys) {
        try {
          const raw = window.sessionStorage.getItem(key);
          if (!raw) continue;
          const state = JSON.parse(raw);
          const sanitized = sanitizeStoredState(state);
          if (sanitized) return sanitized;
        } catch (error) {
          continue;
        }
      }
      return null;
    }

    hasPendingContact() {
      try {
        return window.sessionStorage.getItem(this.contactPendingKey) === 'true';
      } catch (error) {
        return false;
      }
    }

    setPendingContact(pending) {
      try {
        if (pending) window.sessionStorage.setItem(this.contactPendingKey, 'true');
        else window.sessionStorage.removeItem(this.contactPendingKey);
      } catch (error) {
        this.root.dataset.storageUnavailable = 'true';
      }
    }

    clearPostedSuccessQuery() {
      const url = new URL(window.location.href);
      url.searchParams.delete('contact_posted');
      window.history.replaceState(window.history.state || {}, '', url.pathname + url.search + url.hash);
    }

    clearStoredContactAfterSuccess() {
      const name = this.root.querySelector('[data-zv-sc-contact-name]');
      const phone = this.root.querySelector('[data-zv-sc-contact-phone]');
      const email = this.root.querySelector('[data-zv-sc-contact-email]');
      if (name) name.value = '';
      if (phone) phone.value = '';
      if (email) email.value = '';
      this.saveState({
        contactName: '',
        contactPhone: '',
        contactEmail: '',
        currentStep: 4,
        contactMethod: 'callback'
      });
    }

    track(eventName, details) {
      const stepNumber = Number.isFinite(Number(this.currentStep)) ? Number(this.currentStep) : null;
      const stepName = stepNumber ? (STEP_SLUGS[stepNumber - 1] || '') : '';
      const pagePath = window.location.pathname + window.location.search;
      const payload = Object.assign({
        event: eventName,
        component: 'salderingscheck_2027',
        funnel_name: 'salderingscheck_2027',
        funnel_version: '2027_v2',
        page_path: pagePath
      }, details || {});

      // Keep every existing event name intact, but enrich it with consistent
      // funnel dimensions for GA4 / Data Studio. No extra event is fired, so
      // this cannot double the funnel counts or lead conversions.
      if (stepNumber && !Object.prototype.hasOwnProperty.call(payload, 'step_number')) payload.step_number = stepNumber;
      if (stepName && !Object.prototype.hasOwnProperty.call(payload, 'step_name')) payload.step_name = stepName;

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(payload);
    }

    setText(selector, value) {
      const element = this.root.querySelector(selector);
      if (element) element.textContent = value;
    }

  }

  function initialize() {
    document.querySelectorAll('[data-zv-salderingscheck]').forEach((root) => {
      if (root.dataset.zvScInitialized === 'true') return;
      root.dataset.zvScInitialized = 'true';
      try {
        new Salderingscheck(root).init();
      } catch (error) {
        root.dataset.zvScFailed = 'true';
        const box = root.querySelector('[data-zv-sc-error]');
        if (box) {
          box.hidden = false;
          box.textContent = window.ZinVoltI18n.t("the_net_metering_check_could_not_start_a35613");
        }
        if (window.console && typeof window.console.error === 'function') window.console.error('Salderingscheck initialisatie mislukt', error);
      }
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
  else initialize();
})();
